import React, { useContext, useState } from "react";
import LanguageContext from "../../../utils/Contexts/LanguageContext";
import ThemeContext from "../../../utils/Contexts/ThemeContext";
import Constant from "../../Constants";
import GoogleIcon from "../../svg/Google";

function ConnectAccount() {
  const { t } = useContext(LanguageContext);
  const { selectedTheme } = useContext(ThemeContext);
  const { themeStatus } = Constant();
  const [isChecked, setIsChecked] = useState(false);

  const toggleSwitch = () => {
    setIsChecked((prev) => !prev);
  };

  return (
    <div
      id="ConnectAccount"
      className={`card cardSetting ${themeStatus?.[selectedTheme]}`}
    >
      <div className="card-header">
        <h4
          className="card-title responsive-title"
          style={{ fontWeight: "700" }}
        >
          {t("Connected Account")}
        </h4>
      </div>

      <div className="card-body pb-0">
        <label
          className="form-check-label responsive-text mb-2"
          style={{ color: "var(--text-email)" }}
        >
          {t(
            "Integrated features from these accounts make it easier to collaborate with people you know on Front Dashboard."
          )}
        </label>

        <div className="d-flex gap-3 justify-content-between align-items-center py-3">
          <div className="d-flex gap-3 align-items-center">
            <div>
              <GoogleIcon />
            </div>

            <div className="d-flex flex-column">
              <p
                style={{
                  margin: "unset",
                  color: "var(--whiteToBlack)",
                }}
                className="card-text"
              >
                {t("Google")}
              </p>

              <p
                style={{
                  margin: "unset",
                  color: "rgba(108, 116, 122, 1)",
                }}
                className="text-secondary connected-account-text"
              >
                {t("Calendar and contacts")}
              </p>
            </div>
          </div>
          <label
            className="form-check form-switch d-md-flex d-none"
            htmlFor="accounrSettingsPreferencesSwitch1"
          >
            <span className="">
              <input
                type="checkbox"
                className="form-check-input me-0"
                style={{
                  width: "51px",
                  height: "25px",
                  backgroundColor: isChecked
                    ? "rgba(56, 124, 255, 1)"
                    : "var(--toggle-color)",
                }}
                id="accounrSettingsPreferencesSwitch1"
                checked={isChecked}
                onClick={toggleSwitch}
              />
            </span>
          </label>
        </div>
      </div>
    </div>
  );
}

export default ConnectAccount;
